import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
export function BeforeAfterSection() {
  const beforeItems = ['Leads sit in Yelp/Facebook/Google for hours', 'Manual copy-paste into spreadsheets', 'No idea which leads actually booked', "Paying for 4–5 tools that don't connect", 'Follow-up depends on who remembers'];
  const afterItems = ['Every online lead gets an instant response', 'Leads flow into one pipeline automatically', 'See exactly which leads booked and your real ROI', 'One system replaces your entire tool stack', 'Automated follow-up runs 24/7 on autopilot'];
  return <section className="w-full bg-white py-16 md:py-24 px-4" data-id="element-1">
      <div className="max-w-6xl mx-auto" data-id="element-2">
        <div className="text-center mb-14" data-id="element-3">
          <h2 className="text-3xl md:text-5xl font-extrabold text-jet-black mb-4" data-id="element-4">
            From Chaos to <span className="text-viridia-green" data-id="element-5">Autopilot</span>
          </h2>
          <p className="text-lg text-graphite-gray max-w-2xl mx-auto" data-id="element-6">
            Here's what changes when you stop duct-taping tools together and
            install a real system.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-7">
          {/* Before */}
          <div className="bg-red-50 border-2 border-red-200 rounded-xl p-8" data-id="element-8">
            <div className="flex items-center gap-3 mb-6" data-id="element-9">
              <div className="w-10 h-10 bg-red-500 rounded-full flex items-center justify-center" data-id="element-10">
                <XIcon className="w-5 h-5 text-white" strokeWidth={3} data-id="element-11" />
              </div>
              <h3 className="text-2xl font-bold text-red-700" data-id="element-12">Current Chaos</h3>
            </div>
            <ul className="space-y-4" data-id="element-13">
              {beforeItems.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-14">
                  <XIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-1" strokeWidth={2.5} data-id="element-15" />
                  <span className="text-graphite-gray font-medium" data-id="element-16">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* After */}
          <div className="bg-emerald-50 border-2 border-viridia-green/30 rounded-xl p-8 relative" data-id="element-17">
            <div className="absolute -top-3 right-4" data-id="element-18">
              <span className="bg-viridia-green text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-19">
                With Viridia
              </span>
            </div>
            <div className="flex items-center gap-3 mb-6" data-id="element-20">
              <div className="w-10 h-10 bg-viridia-green rounded-full flex items-center justify-center" data-id="element-21">
                <CheckIcon className="w-5 h-5 text-white" strokeWidth={3} data-id="element-22" />
              </div>
              <h3 className="text-2xl font-bold text-deep-teal" data-id="element-23">
                Viridia System
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-24">
              {afterItems.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-25">
                  <CheckIcon className="w-5 h-5 text-viridia-green flex-shrink-0 mt-1" strokeWidth={2.5} data-id="element-26" />
                  <span className="text-graphite-gray font-medium" data-id="element-27">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}